import get from 'lodash/get';
import React from 'react';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import { withMobileDetect } from '../../../hoc/withMobileDetect';
import { TabSwitcher } from '../../molecules/Commons/Client/TabSwitcher';
import { LoginForm } from '../../organisms/General/Login/LoginForm';
import { signUpCard } from '../../../styles/General/SignUp/signUpCard';

class _LoginCard extends React.Component {
  state = { activeTab: 'customer' };

  componentDidMount() {
    const activeTab = get(
      this.props,
      ['location', 'state', 'openTab'],
      'customer',
    );
    this.setState({ activeTab });
  }

  chooseCustomer = () => this.setState({ activeTab: 'customer' });

  chooseDriver = () => this.setState({ activeTab: 'driver' });

  render() {
    const { classes, isMobile } = this.props;
    const { activeTab } = this.state;
    return (
      <div className={classes.container}>
        {isMobile && <h3>Log in as</h3>}
        <TabSwitcher
          activeTab={activeTab}
          leftClick={this.chooseCustomer}
          rightClick={this.chooseDriver}
          leftText={isMobile ? 'A customer' : 'Log in as Customer'}
          rightText={isMobile ? 'A driver' : 'Log in as Driver'}
        />
        <LoginForm role={activeTab} />
      </div>
    );
  }
}

export const LoginCard = compose(
  injectSheet(signUpCard),
  withMobileDetect(),
)(_LoginCard);
